import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        d: "M10.873 9.745v1.88a3.76 3.76 0 0 1-3.758 3.757H4.11a2.255 2.255 0 0 1-2.254-2.255v-2.63c0-1.038.84-1.879 1.878-1.879h.376m18.036 2.255.934-.234a.75.75 0 0 0 .57-.729v-.54a.75.75 0 0 0-.752-.752h-4.741c-1.091 0-2.174.176-3.209.52l-1.759.587a3.76 3.76 0 0 1-2.376 0l-1.76-.586a10.2 10.2 0 0 0-3.207-.52H1.103a.75.75 0 0 0-.751.75v.541c0 .345.234.646.569.73l.934.233m11.27.376c-.733.23-1.519.23-2.252 0m11.272 0v-.752a1.88 1.88 0 0 0-1.878-1.879h-.376m-6.764 1.127v1.88a3.76 3.76 0 0 0 3.758 3.757h3.006a2.254 2.254 0 0 0 2.254-2.255v-.376m-17.848.94 3.382-3.382m8.642 3.382 3.57-3.57",
        stroke: "black",
        "stroke-miterlimit": "10",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }